import { IApplicationState } from '../../../../types/types';
import { getIsUserStarterPlanOnly } from './getIsUserStarterPlanOnly';

export const getShowProFeaturesTrial = (
    state: IApplicationState
): boolean => {
    return getIsUserStarterPlanOnly(state);
};
